export default {
  tool: {
    label: 'クリエイティブツールボックス',
    playable: {
      name: 'プレイアブルテンプレート',
      describe: 'テンプレートを使ってプレイアブル素材を制作',
    },
    normal: {
      name: 'コンテンツエディタ',
      describe: 'PPTを作る感覚で手軽にプレイアブル素材を制作',
    },
    iv: {
      name: '動画をプレイアブル化',
      describe: '動画クリップを活用してプレイアブル素材を制作',
    },
    videoTemplate: {
      name: 'レイアウトテンプレート',
      describe: '多比率・多言語の動画を一括生成',
    },
    videoEditor: {
      name: '動画エディター',
      describe: '動画広告のオンライン編集',
    },
    aiBanner: {
      name: 'URL画像生成',
      describe: '商品リンクから画像クリエイティブを生成',
    },
    actions: {
      demoProject: 'デモプロジェクト',
    },
    PPT: {
      name: '画像から動画',
      describe: '画像素材で動画広告を素早く作成',
    },
    avatarToVideo: {
      name: 'アバターから動画',
      describe: 'デジタルヒューマン付きの動画広告を素早く生成',
    },
    recommendTool: {
      name: 'おすすめツール',
    },
    videoTool: {
      name: 'ビデオツール',
    },
    imageTextTool: {
      name: '画像ツール',
    },
    playableTool: {
      name: 'プレイアブルツール',
    },
    ai: {
      name: 'AI動画',
      describe: '字幕消去、アイコンの置き換え、AI音声などに使用されます。',
    },
    banner: {
      name: 'AI画像生成（Beta）',
      describe: 'プロモーションリンクに基づいた広告画像クリエイティブの生成',
    },
    commonTemplate: {
      describe: '複数の比率、複数の言語バージョンに一括変換可能です。',
    },
  },
  playable: {
    label: {
      name: 'プレイアブルテンプレート',
    },
    gameplay: {
      support: 'クイックレイアウトをサポート',
      nosupport: 'クイックレイアウトはサポートされていません',
    },
    wxgame: {
      support: 'WeChat MiniGameをサポートしています',
    },
    describe:
      '豊富なテンプレートで、クリエイティブな使用シーンと要件に基づいて選択できます。',
    public: '公開',
    collection: 'お気に入り',
    template: 'マイテンプレート',
  },
  template: 'テンプレート',
  video: {
    describe:
      'テンプレートに基づき、素材の組み合わせ分裂、サイズ調整、言語変換をサポートし、動画素材の一括制作を迅速に完了します。',
    filter: {
      search: '検索',
      creative: 'クリエイティブテンプレート',
      multiScale: 'レイアウトテンプレート',
      replaceVideo: 'ビデオ数を入力',
      replaceImage: '画像数を入力',
      replaceText: 'テキスト数を入力',
      videoNum: '動画の数',
      imageNum: '画像の数',
      textNum: 'テキストの数',
      number: 'アイテム',
      mainVideo: '主な動画',
      mainDirection: '主な動画の画面向き',
    },
    table: {
      unMute: 'ミュート解除',
      mute: 'ミュート',
      videoClips: 'ビデオクリップ',
      quickReplace: 'クイックリプレース',
      useTemplate: '使用する',
      rules: '素材の置換はサポートされていません',
      recommend: 'その他のテンプレート',
      noRecommend: '推奨されたテンプレートはありません',
      originality: 'クリエイティブ',
      multScale: 'マルチ比率',
      end: '最後',
      proportionNoEmpty: '比率は必須項目です',
    },
    aiBannerDialog: {
      create: '作成-AI画像生成',
    },
    replaceDialog: {
      create: '作成-レイアウトテンプレート',
      exportScale: '比率をエクスポート',
      addLanguage: '新しい言語を追加',
      languagePlace: '適応する言語を選択してください',
    },
  },
  iv: {
    noProject: 'プロジェクトはまだありません',
    createProject: 'プロジェクトを作成',
  },
}
